const MentionsLegales = () => {
  return (
    <main className="min-h-screen bg-[#080808] text-white">
      <section className="dmi-container py-20 lg:py-28">
        <div className="max-w-4xl mx-auto">

          {/* En-tête */}
          <div className="mb-14">
            <p className="text-[#C9A227] uppercase tracking-[0.3em] text-xs mb-4">
              Informations légales
            </p>

            <h1 className="text-4xl md:text-5xl font-semibold">
              Mentions légales
            </h1>
          </div>

          <div className="space-y-12 text-white/70 leading-7">

            {/* 1. Éditeur */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                1. Éditeur du site
              </h2>

              <div className="space-y-2">
                <p>
                  Le présent site est édité par{" "}
                  <strong className="text-white">
                    DALO MINISTRIES INTERNATIONAL
                  </strong>
                  , association régie par la loi du 1er juillet 1901.
                </p>

                <p>
                  <strong className="text-white">
                    Numéro RNA :
                  </strong>{" "}
                  W912009909
                </p>

                <p>
                  <strong className="text-white">
                    Siège social :
                  </strong>{" "}
                  56 rue Henri Matisse, 91100 Corbeil-Essonnes, France
                </p>

                <p>
                  <strong className="text-white">
                    Adresse électronique :
                  </strong>{" "}
                  <a
                    href="mailto:contact@rolanddalo.com"
                    className="text-[#C9A227] hover:underline"
                  >
                    contact@rolanddalo.com
                  </a>
                </p>
              </div>
            </section>

            {/* 2. Objet de l'association */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                2. Objet de l'association
              </h2>

              <p>
                DALO MINISTRIES INTERNATIONAL a pour objet de développer,
                promouvoir et favoriser des activités chrétiennes sous toutes
                leurs formes en France métropolitaine et dans les DOM/TOM,
                ainsi que la diffusion de l'Évangile et des enseignements
                bibliques.
              </p>
            </section>

            {/* 3. Responsable de publication */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                3. Responsable de la publication
              </h2>

              <p>
                Le directeur de la publication du présent site est{" "}
                <strong className="text-white">
                  Cyril Bokomba
                </strong>
                , en sa qualité de président de DALO MINISTRIES INTERNATIONAL.
              </p>
            </section>

            {/* 4. Hébergement */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                4. Hébergement
              </h2>

              <p>
                Le présent site est hébergé par{" "}
                <strong className="text-white">
                  OVHcloud
                </strong>
                .
              </p>
            </section>

            {/* 5. Propriété intellectuelle */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                5. Propriété intellectuelle
              </h2>

              <div className="space-y-4">
                <p>
                  L'ensemble des contenus présents sur ce site, notamment les
                  textes, photographies, images, vidéos, enseignements,
                  prédications, documents, logos, éléments graphiques et plus
                  généralement tout contenu diffusé sur le site, est protégé
                  par les dispositions applicables en matière de propriété
                  intellectuelle.
                </p>

                <p>
                  Sauf indication contraire, ces contenus sont la propriété
                  de DALO MINISTRIES INTERNATIONAL ou sont utilisés avec
                  l'autorisation de leurs titulaires respectifs.
                </p>

                <p>
                  Toute reproduction, représentation, diffusion, modification,
                  adaptation ou exploitation, totale ou partielle, de ces
                  contenus sans autorisation préalable est interdite, sauf dans
                  les cas prévus par la législation applicable.
                </p>
              </div>
            </section>

            {/* 6. Responsabilité */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                6. Responsabilité
              </h2>

              <div className="space-y-4">
                <p>
                  DALO MINISTRIES INTERNATIONAL s'efforce de fournir sur ce
                  site des informations aussi exactes et à jour que possible.
                  Toutefois, l'association ne peut garantir l'exactitude,
                  l'exhaustivité ou l'actualité de l'ensemble des informations
                  mises à disposition.
                </p>

                <p>
                  DALO MINISTRIES INTERNATIONAL ne saurait être tenue
                  responsable des interruptions temporaires du site, des
                  difficultés techniques ou des dommages résultant de
                  l'utilisation du site, dans les limites prévues par la loi.
                </p>
              </div>
            </section>

            {/* 7. Liens externes */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                7. Liens externes
              </h2>

              <p>
                Le site peut contenir des liens vers des sites ou services
                externes. DALO MINISTRIES INTERNATIONAL n'exerce aucun contrôle
                sur le contenu de ces sites tiers et ne saurait être tenue
                responsable de leur contenu, de leur disponibilité ou de leurs
                pratiques.
              </p>
            </section>

            {/* 8. Données personnelles */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                8. Données personnelles
              </h2>

              <div className="space-y-4">
                <p>
                  Dans le cadre de l'utilisation du site, DALO MINISTRIES
                  INTERNATIONAL peut être amenée à collecter et traiter
                  certaines données à caractère personnel, notamment lorsque
                  vous utilisez les formulaires proposés sur le site.
                </p>

                <p>
                  Les informations relatives aux données collectées, à leurs
                  finalités, à leur durée de conservation ainsi qu'à l'exercice
                  de vos droits sont présentées dans notre politique de
                  confidentialité.
                </p>
              </div>
            </section>

            {/* 9. Cookies et services tiers */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                9. Cookies et services tiers
              </h2>

              <p>
                Le site peut utiliser des cookies ou faire appel à des services
                tiers nécessaires à son fonctionnement ou permettant
                l'intégration de contenus externes. Les modalités d'utilisation
                de ces technologies sont précisées dans la politique de
                confidentialité du site et, lorsque la réglementation l'exige,
                leur utilisation est soumise au consentement de l'utilisateur.
              </p>
            </section>

            {/* 10. Contact */}
            <section>
              <h2 className="text-xl text-white font-medium mb-4">
                10. Contact
              </h2>

              <p>
                Pour toute question relative au site ou aux présentes mentions
                légales, vous pouvez contacter DALO MINISTRIES INTERNATIONAL
                à l'adresse suivante :{" "}
                <a
                  href="mailto:contact@rolanddalo.com"
                  className="text-[#C9A227] hover:underline"
                >
                  contact@rolanddalo.com
                </a>
                .
              </p>
            </section>

            {/* Dernière mise à jour */}
            <section className="pt-6 border-t border-white/10">
              <p className="text-sm text-white/40">
                Dernière mise à jour : octobre 2026.
              </p>
            </section>

          </div>
        </div>
      </section>
    </main>
  );
};

export default MentionsLegales;